
import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Header from "./Header";
import Footer from "./Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { add_addresses, add_to_cart_list, get_address, orders_place, pricing_plan_data } from "../api/Product";
import { add_payment } from "../api/Global";
import payment from "../assets/images/payment.png"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import countryList from 'react-select-country-list';
import { useMemo } from "react";
import Select from "react-select";
import CountryOptions from "./CountryOptions";

const CheckoutForm = () => {
      const navigate = useNavigate();
      const stripe = useStripe();
      const elements = useElements();
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const [success, setSuccess] = useState(false);
      const [paymentMethodId, setPaymentMethodId] = useState(null);
      const [get_pricing_list, set_Pricing_List] = useState([]);
      const location = useLocation();
      const get_cart_totalPrice = localStorage.getItem("cart_totalPrice")
      const locationdata = location.state;
      const [get_address_list, set_Address_list] = useState([]);
      const get_user_data = localStorage.getItem("user");
      const parsedUserData = JSON.parse(get_user_data);
      const countryOptions = useMemo(() => countryList().getData(), []);
      const get_cart_id = localStorage.getItem("add_cart_id")
      const get_cart_title = localStorage.getItem("cart_title")
      const get_cart_description = localStorage.getItem("cart_description")
      const [cartList, setCartList] = useState([]);

      let get_cart_features = [];

      try {
            const stored = localStorage.getItem("cart_features");
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
                  get_cart_features = parsed;
            }
      } catch (error) {
            console.error("Error parsing cart features from localStorage", error);
      }

      // <---------- User Authentication Token ------------>
      const token = localStorage.getItem("token");
      const headers = {
            Authorization: `Bearer ${token}`,
      };

      const [formData, setFormData] = useState({
            name: parsedUserData?.name,
            email: parsedUserData?.email,
            address: "",
            city: "",
            state: "",
            postal_code: "",
            zip: "",
            country: { label: "United States", value: "US" },
            shipping_address: "",
            shipping_city: "",
            shipping_state: "",
            shipping_postal_code: "",
            shipping_country: "US",
            phone: "",
            type: "shipping",
      });
      console.log("formData", formData)
      const [phoneError, setPhoneError] = useState("");

      // Order Summary (Example items)
      const [orderSummary] = useState({
            items: [
                  { name: `${locationdata?.name}`, price: `${locationdata?.discretion}`, quantity: 1 },
                  { name: "Product 2", price: 30, quantity: 2 },
            ],
            subtotal: 80,
            tax: 5,
            total: 85,
      });

      const cardElementOptions = {
            style: {
                  base: {
                        fontSize: "16px",
                        color: "#32325d",

                        "::placeholder": {
                              color: "#aab7c4",
                        },
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                  },
                  invalid: {
                        color: "#fa755a",
                  },
            },
            hidePostalCode: true, // Hides the postal code input if not needed
      };

      // Handle input change
      const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData((prev) => ({
                  ...prev,
                  [name]: value,
            }));
      };

      const handleCountryChange = (selectedOption) => {
            setFormData({ ...formData, country: selectedOption });
      };

      // Phone number change handler
      const handlePhoneChange = (phone) => {
            setFormData({ ...formData, phone });

            // Validate phone immediately
            if (!phone || !isValidPhoneNumber(phone)) {
                  setPhoneError("Please enter a valid phone number.");
            } else {
                  setPhoneError("");
            }
      };

      const fetchCartList = async () => {
            try {
                  const response = await add_to_cart_list(headers);
                  const product = response?.data?.data;
                  console.log("Fetched product:", product);

                  if (product) {
                        setCartList(product);
                  } else {
                        setCartList({}); // Clear cart if empty
                  }
            } catch (error) {
                  console.error("Error fetching cart:", error);
            }
      };
      useEffect(() => {
            fetchCartList();
      }, []);

      // <---------- Handle Order Placement ----------->
      const handle_order_place = async (data, headers) => {
            if (phoneError) {
                  setPhoneError("Please enter a valid phone number.");
                  return;
            }
            try {
                  const response = await orders_place(data, headers);
                  console.log("handle_order_place_response", response);
                  // if (response?.data.message == "Order placed successfully") {
                  //       setError("payment_failed")
                  //       toast.success(response?.message)
                  //       setTimeout(() => {
                  //             navigate("/my-account")
                  //       }, 1500)
                  // }
                  if (response?.data.message === "Order placed successfully") {
                        toast.success(response?.data.message); // Success toast

                        const orderId = response?.data?.order_id; // Extract order ID from response

                        setTimeout(() => {
                        navigate(`/order-detail/${orderId}`); // Navigate to correct order detail page
                        }, 1500);
                  }
            } catch (error) {
                  console.log("error", error);
            }
      };

      const handleSubmit = async (e) => {
            e.preventDefault();
            setLoading(true);
            setError(null);

            if (!stripe || !elements) {
                  setLoading(false);
                  return;
            }

            // ✅ NEW: Check if card is complete before continuing
            const cardElement = elements.getElement(CardElement);
            if (!cardElement) {
                  setError("Card element not found.");
                  setLoading(false);
                  return;
            }

            // We track this outside the handler with onChange, but here’s a fallback check
            if (cardElement._empty) {
                  setError("Please enter your card details.");
                  setLoading(false);
                  return;
            }

            // Step 1: Create Payment Method with Billing & Shipping Details
            // const { error, paymentMethod } = await stripe.createPaymentMethod({
            //       type: "card",
            //       card: elements.getElement(CardElement),
            //       billing_details: {
            //             name: formData.name,
            //             email: formData.email,
            //             address: {
            //                   line1: formData.address,
            //                   city: formData.city,
            //                   state: formData.state,
            //                   postal_code: formData.postal_code,
            //                   country: formData.country,
            //             },
            //       },
            // });

            if (error) {
                  setError(error.message);
                  setLoading(false);
                  return;
            }

            // setPaymentMethodId(paymentMethod.id);

            const data = {
                  paymentMethodId: 'pm_card_visa',
                  billingDetails: formData,
                  cart_id: allCartIds.join(","),
                  price: get_cart_totalPrice
                  // orderSummary: orderSummary,
            }

            const payload = {
                  ...formData,
            };

            // const result = await add_payment(data, headers);
            // console.log("result", result)
            // const result = await response.json();

            // if (result?.data?.success) {
            // setSuccess(true);
            handle_order_place(data, headers);
            const response = await add_addresses(payload, headers)
            console.log("add_addresses_response", response)
            // } else {
            // setError(result.message);
            // }

            setLoading(false);
      };


      useEffect(() => {
            const handle_pricing_plan_data = async () => {
                  try {
                        const response = await pricing_plan_data();
                        set_Pricing_List(response?.data?.pricing_plans && response?.data?.pricing_plans[response?.data?.pricing_plans?.length - 1]);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_pricing_plan_data();
      }, [])

      useEffect(() => {
            const handle_address_list = async () => {
                  try {
                        const response = await get_address(headers);
                        set_Address_list(response?.data || []);

                        if (response?.data?.length > 0) {
                              const shippingAddresses = response?.data?.filter(item => item?.type === "shipping");

                              if (shippingAddresses?.length > 0) {
                                    const lastShipping = shippingAddresses[shippingAddresses?.length - 1]; // ✅ Last one

                                    setFormData(prevData => ({
                                          ...prevData,
                                          id: lastShipping.id || '',
                                          fullName: lastShipping.fullName || '',
                                          address: lastShipping.address || '',
                                          city: lastShipping.city || '',
                                          zip: lastShipping.zip || '',
                                          postal_code: lastShipping.zip || '', // optional if you want to sync
                                          phone: lastShipping.phone || '',
                                          email: parsedUserData?.email || '',
                                          state: lastShipping.state || '',
                                          country: lastShipping.country || 'US',
                                    }));
                              } else {
                                    console.warn("No shipping address found");
                              }
                        } else {
                              console.warn("No address data available");
                        }
                  } catch (error) {
                        console.error("Error fetching address:", error);
                  }
            };

            handle_address_list();
      }, []);


      const allCartIds = cartList?.map(item => item.id);


      return (
            <>
                  <Header />
                  {/* <-------- ToastContainer ------------> */}
                  <ToastContainer style={{ marginTop: "120px" }} />
                  <div className="relative py-10 md:py-24">
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent"></div>
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                              <div className="relative">
                                    <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/10 via-transparent to-blue-500/10 blur-3xl"></div>
                                    <div className="relative backdrop-blur-xl bg-white rounded-xl p-3 lg:p-8 h-full transition-colors">
                                          <div className="grid lg:grid-cols-3 gap-6">
                                                <div className="md:col-span-2 order-2 md:order-1 lg:order-1">
                                                      <form className="space-y-4" onSubmit={handleSubmit}>
                                                            <h3 className="text-2xl font-bold mb-8">Billing Details</h3>
                                                            {/* 🔹 Billed-as Descriptor (GoDaddy Style) */}
                                                            <p className="text-gray-600 text-sm mb-6">
                                                                 Billed-as <a
                                                                        href="https://locknpay.com"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="underline text-blue-600"
                                                                  >
                                                                        <strong>locknpay.com</strong>
                                                                  </a>
                                                            </p>
                                                            {/* 🔹 End Descriptor */}
                                                            <div className="grid grid-cols-2 gap-4">
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">Name:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" type="text" name="name" value={formData?.name} onChange={handleChange} required />
                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">Email:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" type="email" name="email" value={formData?.email} onChange={handleChange} required />
                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">Address:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" type="text" name="address" value={formData.address} onChange={handleChange} required />
                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">City:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500
                                                                   border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                              type="text" name="city" value={formData.city} onChange={handleChange} required />
                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">State:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500
                                                                   border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                              type="text" name="state" value={formData.state} onChange={handleChange} required />
                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">ZIP Code:</label>
                                                                        <input className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border
                                                                   border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                              type="text"
                                                                              name="zip"
                                                                              value={formData.zip}
                                                                              onChange={(e) => {
                                                                                    const value = e.target.value;

                                                                                    setFormData((prev) => ({
                                                                                          ...prev,
                                                                                          zip: value,
                                                                                          postal_code: value, // Same value for both
                                                                                    }));
                                                                              }}
                                                                        />
                                                                  </div>
                                                                  {/* <div className="mb-4">
                                                                  <label className="block text-sm font-medium text-gray-400 mb-1">Country:</label>
                                                                  <Select
                                                                        options={countryOptions}
                                                                        value={formData.country}
                                                                        onChange={handleCountryChange}
                                                                        placeholder="Select billing country"
                                                                  />
                                                            </div> */}

                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">Country:</label>
                                                                        <select className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100"
                                                                              name="country"
                                                                              value={formData.country}
                                                                              onChange={handleChange}
                                                                        >
                                                                              <CountryOptions />
                                                                        </select>

                                                                  </div>
                                                                  <div>
                                                                        <label className="block text-sm font-medium text-gray-400 mb-1">Phone:</label>
                                                                        <PhoneInput defaultCountry="US" placeholder="Enter phone number" value={formData.phone} onChange={handlePhoneChange} className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-blue-200 focus:ring-1 focus:ring-blue-100" />
                                                                        {phoneError && (
                                                                              <p className="text-red-500 text-xs mt-1">{phoneError}</p>
                                                                        )}

                                                                  </div>
                                                            </div>
                                                            <h3 className="text-2xl font-bold mb-8">Payment Details</h3>
                                                            <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f8f9fa" }}>
                                                                  <CardElement
                                                                        options={cardElementOptions}
                                                                        onChange={(event) => {
                                                                              if (!event.complete) {
                                                                                    setError("Please complete your card details.");
                                                                              } else {
                                                                                    setError(null);
                                                                              }
                                                                        }}
                                                                  />
                                                            </div>


                                                            {/* <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f8f9fa" }}>
                                                            <CardElement options={cardElementOptions} />
                                                      </div> */}

                                                            {/* <div>
                                                            <button type="submit" disabled={!stripe || loading} style={{ marginTop: "20px", width: "100%", padding: "10px", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px" }}>
                                                                  {loading ? "Processing..." : "Pay Now"}
                                                            </button>
                                                      </div> */}
                                                            <div className="mt-4 sm:justify-center sm:mt-0">
                                                                  <img src={payment} alt="Payment Methods" className="w-64 " />
                                                            </div>
                                                            <div>
                                                                  <button type="submit" disabled={loading}
                                                                        style={{
                                                                              marginTop: "20px", width: "100%", padding: "10px", backgroundColor: "#007bff",
                                                                              color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px"
                                                                        }}>
                                                                        {loading ? "Processing..." : "Pay Now"}
                                                                  </button>
                                                            </div>
                                                            
                                                      </form>
                                                      {/* <div>
                                                      <h2 className="text-2xl font-bold mb-8">Checkout</h2>
                                                      <div className="bg-gray-100 rounded-lg p-4">

                                                            <h3 className="text-lg font-medium">Order Summary</h3>
                                                            <p>{locationdata?.name} Plan - {locationdata?.discretion}</p>

                                                            <ul className="p-0"> <span>Features</span>
                                                                  {locationdata?.features?.map((item, index) => (
                                                                        <li key={index}>
                                                                              {item}
                                                                        </li>
                                                                  ))}
                                                            </ul>

                                                            <p className="border-b border-gray-200 pb-3">Subtotal: ${locationdata.price.monthly}</p>
                                                            <h3>Total: ${locationdata.price.monthly}</h3>
                                                      </div>
                                                      {error && <div style={{ color: "red" }}>{error}</div>}
                                                      {success && <div style={{ color: "green" }}>Payment Successful! Payment Method ID: {paymentMethodId}</div>}
                                                </div> */}
                                                </div>
                                                <div className="w-full mx-auto bg-white rounded-xl  md:order-2 lg:order-2">
                                                      <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">Checkout</h2>

                                                      {/* Order Summary */}
                                                      <div className="bg-gray-100 rounded-lg p-4">
                                                            <h3 className="text-lg font-semibold text-gray-700 mb-2">Order Summary</h3>
                                                            <p className="text-gray-600">
                                                                  {cartList?.map((cartList_result, index) => (
                                                                        <div key={index} className="mb-6 border-b pb-4">
                                                                              {cartList_result?.product && (
                                                                                    <>
                                                                                          <h2 className="text-lg font-semibold">{cartList_result?.product?.type}</h2>
                                                                                          <h3 className="text-sm">{cartList_result?.product?.title}</h3>
                                                                                          <p className="text-gray-600">${cartList_result?.product?.price}</p>
                                                                                          <p className="text-sm text-gray-500">{cartList_result?.product?.billing_cycle}</p>
                                                                                          {
                                                                                                get_cart_features.length > 0 && (
                                                                                                      <div className="mt-4">
                                                                                                            <h4 className="text-md font-medium text-gray-700">Features:</h4>
                                                                                                            <ul className="mt-2 space-y-2">
                                                                                                                  {get_cart_features?.map((item, index) => (
                                                                                                                        <li key={index} className="text-sm flex items-center text-gray-600">
                                                                                                                              <svg
                                                                                                                                    className="w-6 h-6 text-green-400 mr-2"
                                                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                                                    fill="none"
                                                                                                                                    viewBox="0 0 24 24"
                                                                                                                                    stroke="currentColor"
                                                                                                                              >
                                                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                                                                                              </svg>

                                                                                                                              {item?.feature}
                                                                                                                        </li>
                                                                                                                  ))}
                                                                                                            </ul>
                                                                                                      </div>
                                                                                                )
                                                                                          }
                                                                                    </>
                                                                              )}

                                                                              {cartList_result?.development && (
                                                                                    <>
                                                                                          <h2 className="text-lg font-semibold">{cartList_result?.development?.type}</h2>
                                                                                          <h3 className="text-sm">{cartList_result?.development?.title}</h3>
                                                                                          <p className="text-gray-600">${cartList_result?.development?.price}</p>
                                                                                    </>
                                                                              )}
                                                                              {
                                                                                    cartList_result?.order_type == "domain" && (
                                                                                          <>
                                                                                                <h2 className="text-lg font-semibold">{cartList_result?.order_type}</h2>
                                                                                                <h3 className="text-sm">{cartList_result?.domain}</h3>
                                                                                                <p className="text-gray-600">${cartList_result?.domain_amount}</p>
                                                                                          </>
                                                                                    )
                                                                              }
                                                                        </div>
                                                                  ))}
                                                                  {/* <span className="font-medium">

                                                                        {
                                                                              get_pricing_list?.title != null && (
                                                                                    <>
                                                                                          {get_cart_title ? get_cart_title : get_pricing_list?.title} :
                                                                                    </>
                                                                              )
                                                                        }
                                                                  </span> {get_cart_description ? get_cart_description : "- A flexible hosting solution designed to let you pay only for the resources you use."} */}
                                                            </p>

                                                            {/* Features List */}

                                                            {/* Pricing Details */}
                                                            <div className="mt-6 border-t border-gray-300 pt-4">
                                                                  <p className="text-gray-600 text-md">Subtotal: <span className="font-semibold">${get_cart_totalPrice
                                                                        ? Number(get_cart_totalPrice).toFixed(2)
                                                                        : Number(get_pricing_list?.price || 0).toFixed(2)}
                                                                  </span></p>
                                                                  <h3 className="text-xl font-bold text-gray-800 mt-2">Total :  <span className="text-green-600">${get_cart_totalPrice
                                                                        ? Number(get_cart_totalPrice).toFixed(2)
                                                                        : Number(get_pricing_list?.price || 0).toFixed(2)}
                                                                  </span></h3>
                                                            </div>
                                                      </div>

                                                      {/* Payment Messages */}
                                                      {/* {error && <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">{error}</div>} */}
                                                      {error == "payment_failed" ? (
                                                            <div style={{ color: 'red', marginTop: '10px' }}>
                                                                  Payment failed. Please visit our{" "}
                                                                  <Link to="/contact-us" style={{ color: "#007bff", textDecoration: "underline" }}>
                                                                        Contact Us
                                                                  </Link>{" "}
                                                                  page for assistance.
                                                            </div>
                                                      ) : error && (
                                                            <div style={{ color: 'red', marginTop: '10px' }}>
                                                                  {error}
                                                            </div>
                                                      )}

                                                      {success && (
                                                            <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-md">
                                                                  Payment Successful! <br />
                                                                  <span className="text-gray-700 text-sm">Payment Method ID: {paymentMethodId}</span>
                                                            </div>
                                                      )}
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <Footer />
            </>
      );
};

export default CheckoutForm;
